import React from 'react';
import '../App.css';
import CommentCreator from './CommentCreator';
import TimeAgo from 'react-timeago';

export default class Comment extends React.Component {

  constructor(props) {
    super(props);
    let replies = [];
    if (this.props.data && this.props.data.replies) {
      replies = this.props.data.replies;
    }
    this.state = {replies: replies};
  }

  upvote(event) {
    event.preventDefault();
    this.vote('up');
  }

  downvote(event) {
    event.preventDefault();
    this.vote('down');
  }

  reply(event) {
    event.preventDefault();
    console.log('User clicked reply');
    // Show reply input field.
    this.setState({showReplyCreator: true}); 
  }

  fetchEarlierComments(e) {
    e.preventDefault();
    // Call for the next page of comments..
    let url = window.location.protocol + '//' + window.location.host;
    let page = this.state.commentPage + 1;
    let that = this;
    let fetchParams = {
      method: 'GET',
      uri: `/api/v1/posts/${this.props.post._id['$oid']}/comments?comment_page=${page}&comment_id=${this.props.data._id['$oid']}`,
      //uri: `${url}/api/v1/posts/${this.props.post._id['$oid']}/comments?comment_page=${page}&comment_id=${this.props.data._id['$oid']}`,
    };
    fetch(fetchParams.uri, fetchParams, function(err, data) {
      if (err) {
        console.log('Error fetching previous comments: ' + err);
      } else {
        // Should have data...
        console.log('Got comment page data.. current page is: ' + page);
        console.log('Comment page data here: ' + JSON.stringify(data));
        let comments = that.state.replies;
        let response = JSON.parse(data.body);
        for (let i = 0; i < response.comments.length; i++) {
          comments.push(response.comments[i]);
        }
        that.setState({replies: comments, comment_total: response.comment_total});
      }
    });
  }

  vote(direction) {
    console.log('User voted ' + direction);
    let url = window.location.protocol + '//' + window.location.host; 
    let voteParams = {
      uri: `${url}/api/v1/posts/${this.props.post._id['$oid']}/comments/${this.props.data._id['$oid']}/${direction}vote`,
      method: 'PUT',
    };
    if (this.props.data && this.props.data.myvote && this.props.data.myvote.direction === direction) {
      // We have already voted this direction. Delete the vote.
      voteParams = {
        // uri: `${url}/api/v1/posts/${this.props.post._id['$oid']}/comments/${this.props.data._id['$oid']}/vote`,
        uri: `/api/v1/posts/${this.props.post._id['$oid']}/comments/${this.props.data._id['$oid']}/vote`,
        method: 'DELETE',
      };
    }
    let that = this;
    try {
      fetch(voteParams.uri, voteParams, function(err, data) {
        if (err) {
          console.log('Voting error: ' + err);
        } else {
          let comment = JSON.parse(data.body)['comments'];
          if (!comment) {
            console.log('Something is wrong with our vote: ' + data.body);
            return;
          }
          // now set State so the post can redraw correctly.
          if (comment && typeof comment.upvotes !== 'undefined') {
            if (voteParams.method === 'DELETE') {
              delete that.props.data['myvote'];
              that.setState({upvotes: comment.upvotes, downvotes: comment.downvotes, voteDir: undefined});
            } else {
              that.props.data.myvote = {'direction': direction};
              that.setState({voteDir: direction, upvotes: comment.upvotes, downvotes: comment.downvotes});
            }
          } else {
            console.log('Something not defined in comment body: ' + data.body);
          }
        }
      });
    } catch(e) {
      console.log('Error putting vote data: ' + e);
    }
  }

  showProfile(e, user) {
    e.preventDefault();
    this.props.app.showProfile(user);
  }

  render() {
    let greyFontClass = 'commentActionFont';
    let blueFontClass = 'commentActionFontBlue';
    let upvoteFont = greyFontClass;
    let downvoteFont = greyFontClass;
    let myVoteDirection = ''; 
    let replyCreator = '';
    let upvotes = 0;
    let downvotes = 0;
    let role = '';
    if (this.state && this.state.voteDir) {
      myVoteDirection = this.state.voteDir;
    } else if (this.props.data && this.props.data.myvote) {
      myVoteDirection = this.props.data.myvote.direction;
    }
    if (this.state && typeof this.state.upvotes !== 'undefined') { 
      upvotes = this.state.upvotes;
      downvotes = this.state.downvotes;
    } else if (this.props && this.props.data && typeof this.props.data.upvotes !== 'undefined') {
      upvotes = this.props.data.upvotes;
      downvotes = this.props.data.downvotes;
    }
    if (myVoteDirection) {
      if (myVoteDirection === 'down') {
        downvoteFont = blueFontClass;
      } else {
        upvoteFont = blueFontClass;
      }
    }
    let replies = [];
    let prevLink = '';
    if (this.state.replies) {
      for (let i=0; i < this.state.replies.length; i++) {
        let reply = this.state.replies[i];
        replies.push(<Comment key={reply._id['$oid']} app={this.props.app} parentComment={this} data={reply} post={this.props.post} />);
      }
    }
    if (this.props.data.comment_total > replies.length) {
      prevLink = <div className='prevLinkReplyDiv'><span className='fakeLink' onClick={(e) => this.fetchEarlierComments(e)}><font className='commentActionFontBlue'>Mais respostas</font></span></div>;
    }
    if (this.state.showReplyCreator) {
      replyCreator = <CommentCreator user={this.props.app.state.user} commentId={this.props.data._id['$oid']} post={this.props.post} commentObj={this} postObj={this.props.postObj} />;
    }
    let commentClassName = this.props.data.comment_id ? 'commentReply' : 'comment';
    if (this.props.data.user && this.props.data.user.role) {
      if (this.props.data.user.role.name === 'Fundador') {
        role = <font className='fundadorRoleLabel'> &#9733;</font>;
      } else if (this.props.data.user.role.name === 'Moderador') {
        role = <font className='moderadorRoleLabel'> &#9733;</font>;
      } else {
        role = <b> &#9733;</b>;
      }
    }
    return (
      <div className={commentClassName}>
        <div className='commentHeader'>
          <span className='fakeLink' onClick={(e) => this.showProfile(e, this.props.data.user)}><img className='avatar' style={{width: '30px'}} src={this.props.data.user.avatar} alt='' /></span>
          <div className='commentHeaderText'>
            <div onClick={(e) => this.showProfile(e, this.props.data.user)}>
              <span className='fakeLink' onClick={(e) => this.showProfile(e, this.props.data.user)}>{this.props.data.user.username}</span>{role}
            </div>
            <span className='timeAgo'><TimeAgo date={this.props.data.created_at} /></span>
          </div>
        </div>
        <div className='postBody'>{this.props.data.text}</div>
        <div className='commentActions'>
          <span className='fakeLink' onClick={(e) => this.upvote(e)}><font className={upvoteFont}>Gosta ({upvotes})</font></span>
          &nbsp;&bull;&nbsp;
          <span className='fakeLink' onClick={(e) => this.downvote(e)}><font className={downvoteFont}>Não Gosta ({downvotes})</font></span>
          &nbsp;&bull;&nbsp;
          <span className='fakeLink' onClick={(e) => {this.props.parentComment ? this.props.parentComment.reply(e) : this.reply(e)}}><font className={greyFontClass}>Responder</font></span>
        </div>
        {replies}
        {prevLink}
        {replyCreator}
      </div>
    );
  }
}
